const BRAND_CODES = {
  privacyShield: 'privacy',
  privacyMedicalShield: 'psms',
  missGroupSafe: 'mgsafe',
  domeneShop: 'dshop',
  domainkeskusSafe: 'dsafe',
  partyhat: 'partyhat',
  protectIV: 'protectiv',
  phSafe: 'phsafe',
} as const;

export default BRAND_CODES;
